export function initItemcardCrosssellerControls() {
    document.querySelectorAll('.itemcardCrosssellerList').forEach(container => {
        const list = container.querySelector('.itemlist');
        if (!list) return;

        const items = Array.from(list.querySelectorAll('.itemlistElement'));
        if (items.length === 0) return;

        const originalOrder = [...items];
        const sortBtn = container.querySelector('.js-crosssellerSortBtn');
        const sortIcon = sortBtn?.querySelector('.icon');
        const searchInput = container.querySelector('.js-crosssellerSearch');

        let sortState = 0;

        sortBtn?.addEventListener('click', () => {
            sortState = (sortState + 1) % 3;
            applySort(list, items, originalOrder, sortState, sortIcon);
        });

        searchInput?.addEventListener('input', () => {
            filterItems(items, searchInput.value);
        });
    });
}

const SORT_ICONS = ['icon-sorting', 'icon-arrow-up', 'icon-arrow-down'];

function applySort(list, items, originalOrder, state, iconEl) {
    iconEl.className = `icon ${SORT_ICONS[state]}`;

    const sorted = state === 1
        ? [...items].sort((a, b) => a.dataset.itemno.localeCompare(b.dataset.itemno))
        : state === 2
            ? [...items].sort((a, b) => b.dataset.itemno.localeCompare(a.dataset.itemno))
            : [...originalOrder];

    sorted.forEach(item => list.appendChild(item));
}

function filterItems(items, value) {
    const q = value.toLowerCase();
    items.forEach(item => {
        const itemno = (item.dataset.itemno || '').toLowerCase();
        const name = (item.querySelector('.itemlistElement__name')?.textContent || '').toLowerCase();
        item.style.display = (!q || itemno.includes(q) || name.includes(q)) ? '' : 'none';
    });
}
